export default "__VITE_ASSET__C7a2v69r__"